export enum TenantType {
  GeneralContractor = 'GENERAL_CONTRACTOR',
  Subcontractor = 'SUBCONTRACTOR',
  Standard = 'STANDARD',
}
